import React, {FC, ReactElement, useEffect, useState} from "react";
import LoaderWithCompanySelected from "../../components/LoaderWithCompanySelected";
import {companyApi} from "../../backend/CompanyApi";
import {selectedCompanyStore} from "../../store/SelectedCompany";
import {observer} from "mobx-react";

interface IProps {

}

const DriveRedirect: FC<IProps> = observer((): ReactElement => {
    const [error, setError] = useState('');

    useEffect(() => {
        companyApi.getDriveUrl(selectedCompanyStore.companyId)
                .then(({result, error}) => {
                    if (error) {
                        setError(error)
                    } else {
                        if (result) {
                            window.location.href = result
                        } else {
                            setError("No redirect link found")
                        }
                    }
                })
                .catch(setError)
    }, [])
    return <>
        <LoaderWithCompanySelected loading={true} error={error}/>
    </>
});

export default DriveRedirect